import QueryAll from "./queryAll.gql";
import QueryList from "./queryList.gql";
import FilterRoom from "./filterRoom.gql";
import FrequentRoom from "./frequentRoom.gql";
import SendCommand from "./sendCommand.gql";
import SearchLocation from "./searchLocation.gql";
import {mutationHdl, queryHdl} from '../graphqlHdr'

export default {
  // queryAll: (vueSelf, variables) => queryHdl.call(vueSelf, QueryAll, variables),
  // 查询会议室列表
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, variables),
  // 查询会议室
  filterRoom: (vueSelf, variables) => queryHdl.call(vueSelf, FilterRoom, variables),
  // 常用会议室
  frequentRoom: (vueSelf, variables) => queryHdl.call(vueSelf, FrequentRoom, variables),
  // 发送命令
  sendCommand: (vueSelf, variables) => mutationHdl.call(vueSelf, SendCommand, variables),
  // 区域
  queryLocation: (vueSelf, variables) => queryHdl.call(vueSelf, SearchLocation, variables),
}
